import { render } from "./InfoWidget.vue?vue&type=template&id=57a83dc6"
import script from "./InfoWidget.vue?vue&type=script&lang=js"
export * from "./InfoWidget.vue?vue&type=script&lang=js"
script.render = render

export default script